<template>
  <div>
    <b-container>
      <little-bar
        class="contact-nav"
        goWay="index"
        :current="current"
        :navlist="navlist"
        copyright="forum"
        @changeCurrent="changeCurrent"
      ></little-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </b-container>
  </div>
</template>
<script>
import littleBar from "@/forumcomponents/littleBar";
export default {
  data() {
    return {
      current: 0,
      currentName: "",
      navlist: [
        {
          // text: '合作支持',
          text: this.$t("lang.cooparationSupport"),
          path: "/forum/contact/list?type=0&typeId=3&index=0",
        },
        {
          // text: '媒体支持',
          text: this.$t("lang.mediaSupport"),
          path: "/forum/contact/list?type=1&typeId=4&index=1",
        },
        {
          // text: '学术合作机构',
          text: this.$t("lang.amedemicConcil"),
          path: "/forum/contact/list?type=2&typeId=5&index=2",
        },
        {
          // text: '志愿者报名',
          text: this.$t("lang.VoluteerSign"),
          path: "/forum/contact/list?type=3&mode=signup&typeId=6&volunteer=1&index=3",
        },
        {
          // text: '实习生报名',
          text: this.$t("lang.traineeSign"),
          path: "/forum/contact/list?type=4&mode=signup&typeId=7&volunteer=2&index=4",
        },
        {
          // text: '全职工作',
          text: this.$t("lang.FulltimeJob"),
          path: "/forum/contact/list?type=5&mode=signup&typeId=8&volunteer=3&index=5",
        },
        {
          // text: '联系我们',
          text: this.$t("lang.contact"),
          path: "/forum/contact/list?type=6&typeId=9&index=6",
        },
      ],
    };
  },
  components:{
      littleBar,
  },
  mounted() {
    this.current = this.$route.query.type;
  },
  watch: {
    $route(to, from) {
      this.current = to.query.type;
    },
  },
  methods: {
    changeCurrent(index, path) {
      this.current = index;
      this.$router.push(path);
      // console.log(index, path)
    },
  },
};
</script>
<style lang="scss" scoped>
.term-btn {
  margin-left: 1rem;
  cursor: pointer;
  .text {
    display: flex;
    align-items: center;
  }
  .drop-down {
    display: none;
  }
}

.term-btn:hover {
  .drop-down {
    position: relative;
    display: block;
    background-color: #f2f2f2;
    z-index: 99;
    text-align: center;
    .drop-item:hover {
      color: $forum-theme-blue;
      cursor: pointer;
    }
  }
}
</style>
